import { useEffect } from 'react'
import * as Sentry from '@sentry/react-native'
import { useCustomer, useStaff, useStore } from './useSession'
import AppConfig from 'config'

const useSentryContext = () => {
  const staff = useStaff()
  const customer = useCustomer()
  const store = useStore()

  useEffect(() => {
    try {
      Sentry.setTag('version', AppConfig.app.version)
      Sentry.setTag('hash', AppConfig.app.hash)
      Sentry.setTag('build_date', AppConfig.app.date)
    } catch (e) {
      console.log('Failed to set tags', e)
      Sentry.captureException(e, {
        tags: {
          location: 'useSentryContext',
        },
      })
    }
  }, [])

  useEffect(() => {
    Sentry.setUser(
      customer
        ? {
            id: customer.id,
            username: customer.ref,
            email: customer.email ?? undefined,
          }
        : null
    )
    Sentry.setTag('customer', customer?.ref)
  }, [customer])

  useEffect(() => {
    Sentry.setTag('store', store?.ref)
  }, [store])

  useEffect(() => {
    Sentry.setTag('staff', staff?.ref)
  }, [staff])
}

export default useSentryContext
